module.exports = __webpack_public_path__ + "static/img/doctor.c9a95ec4.82e67a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor.c9a95ec4.png
// module id = RhPQ
// module chunks = 1